const triggers = document.body.querySelectorAll(".js-modal-trigger");
const defaultOpenModals = document.body.querySelectorAll(
  ".js-modal--default-open"
);

const closeModal = (modal) => {
  const closeButton = modal.querySelector(".js-modal-close");
  closeButton.addEventListener("click", () => {
    modal.close();
  });
};

const triggerModals = () => {
  defaultOpenModals.forEach((modal) => {
    modal.showModal();
    closeModal(modal);
  });
  triggers.forEach((trigger) => {
    const modalId = trigger.dataset.modalId;
    if (modalId && modalId.length > 0) {
      const modal = document.getElementById(modalId);
      if (!modal) return;

      trigger.addEventListener("click", () => {
        modal.showModal();
      });
      closeModal(modal);
    }
  });
};

export default triggerModals;



// WEBPACK FOOTER //
// ./src/components/components/consumer/modal/modal.js